const MONTHS = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
]

/* Formats a stored ISO date ("2026-10-21" or a full timestamp) the same way on the server and in the browser. */
export const formatDate = (value: string | null | undefined): string => {
    if (!value) return ''

    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value)

    if (!match) return ''

    const [, year, month, day] = match
    const monthName = MONTHS[Number(month) - 1]

    if (!monthName) return ''

    return `${monthName} ${Number(day)}, ${year}`
}

export const getInitials = (name: string | null | undefined): string => {
    if (!name) return ''

    return name
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map(part => part.charAt(0).toUpperCase())
        .join('')
}
